import styled from "styled-components";
import { FormControlLabel } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const StyledTermsOfUse = styled(FormControlLabel)`
    align-items: baseline !important;
    margin-top: 3.5rem;

    @media ${breakpoints.xs} {
        margin-top: 2rem;
    }
`;
